export const COMPARISON_CONSTANTS_OPERATIONS = {
  title: "Resilient by Design: Traditional vs OneMind Operations",
  desc: "Legacy models isolate NOC, SOC, and helpdesk support — slowing down response and raising risk. OneMind brings them together for faster action, smarter protection, and business continuity.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Traditional IT Ops & Support Models",
      points: [
        "Separate vendors for monitoring, security, and user support",
        "Manual ticketing systems and reactive incident response",
        "No integration between NOC and SOC workflows",
        "No coverage for regulatory compliance or audit readiness",
        "Limited visibility into performance and risk trends",
        "Helpdesk delays due to poor coordination and escalation paths",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind NOC, SOC & Helpdesk Services",
      points: [
        "Unified platform with 24/7 network monitoring, security, and support",
        "Real-time threat detection with SIEM + automated escalation",
        "Integrated SOC/NOC workflows for faster resolution and risk reduction",
        "Built-in compliance support for SOC 2, GDPR, CCPA, and PCI",
        "Custom reporting dashboards with performance and incident insights",
        "Tiered helpdesk with SLA-backed support and fast user resolution",
      ],
    },
  ],
};
